import { API_URL } from '@/constants/env.constants.ts';

export const API_BASE_URL = `${API_URL}/api/v1`;
export const TOKEN_TYPE = 'Bearer ';
export const REQUEST_HEADER_AUTH_KEY = 'Authorization';
export const TOKEN_NAME_IN_STORAGE = 'token';
